module.exports = __webpack_public_path__ + "img/hadiah-2jt.d7cb4252.png";